import {render as toPlainText} from 'datocms-structured-text-to-plain-text'
import {type Blockquote, type Code} from 'datocms-structured-text-utils'
import {type ReactNode} from 'react'
import {wysiwygComponentVariants} from '~/cms/components/WYSIWYG/_utils/variants'
import {
  HgArticleWYSIWYGBlockQuote,
  HgArticleWYSIWYGCodeBlock,
  HgArticleWYSIWYGDivider,
} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'

export const handleBlockQuoteNode = ({
  node: {attribution, ...props},
  key,
}: {
  children: ReactNode
  node: Blockquote
  key: string
}) => {
  // Only show the block quote text, not the attribution and strip out html tags
  const plainText = toPlainText({...props})
  const {blockQuote} = wysiwygComponentVariants()
  return (
    <HgArticleWYSIWYGBlockQuote
      key={key}
      quote={plainText}
      attribution={attribution}
      className={blockQuote()}
    />
  )
}

export const handleCodeBlockNode = ({
  node: {code, language},
  key,
}: {
  node: Code
  key: string
}) => {
  const {codeBlock} = wysiwygComponentVariants()
  return (
    <HgArticleWYSIWYGCodeBlock
      key={key}
      code={code}
      language={language}
      className={codeBlock()}
    />
  )
}

export const handleArticleThematicBreak = ({key}: {key: string}) => {
  const {divider} = wysiwygComponentVariants()
  return <HgArticleWYSIWYGDivider key={key} className={divider()} />
}
